import React, { useState, useRef, useCallback } from "react";
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';
import "./CustomWebcam.css"

export function CustomWebcam({setImgSrc} : {setImgSrc: React.Dispatch<React.SetStateAction<string | null>>}) {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

  const webcamRef = useRef<Webcam>(null);

  const capture = useCallback(() => {
    const ss = webcamRef.current?.getScreenshot();
    if (ss) {
      console.log(`camera image size: ${Math.ceil(ss.replace(/^data[^,]+,/,'').length * 6 / 8 / 1024 )}MB`)
      if (Math.ceil(ss.replace(/^data[^,]+,/,'').length * 6 / 8 / 1024 ) > 2048) {
        window.alert("Please upload a photo less than 2MB.")
        return
      }
      setImgSrc(ss);
    }
    closeModal()
  }, [webcamRef]);

  return (
    <div>
      <button type="button" className="button" onClick={() => setOpen(true)}>
        Take a picture
      </button>
    
      <Popup
        open={open}
        closeOnDocumentClick
        onClose={closeModal}
      >
        <div className="modal">
          <a className="close" onClick={closeModal}>
            &times;
          </a>
          <Webcam audio={false} height={450} width={600} ref={webcamRef} screenshotFormat="image/png" />
          <div className="btn-container">
            <button onClick={capture}>Capture photo</button>
          </div>
        </div>
      </Popup>
    </div>
  );
}